export enum IconVariant {
  Default = 'default',
  Circle = 'circle',
  CircleFilled = 'circleFilled',
  HexagonFilled = 'hexagonFilled',
  SquareFilled = 'squareFilled',
  TriangleFilled = 'triangleFilled',
}
